import React, { useState } from "react";
import config from "../../config";
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { toast } from 'react-toastify';
const company = JSON.parse(sessionStorage.getItem("companyDetails") || "{}");
const Companycurrency = company?.currency ?? "";
export default function CouponMaster() {
  const [amountType, setAmountType] = useState("");
  const [amount, setAmount] = useState("");

  const saveCoupon = async () => {
    if (!amountType || !amount) {
      toast.error("All fields are required");
      return;
    }

    const token = sessionStorage.getItem("token");
    const companyid = company?.id;
    const payload = {
      amountType,   // "PERCENT" or "RUPEE"
      amount,
      companyid,
    };

    try {
      await axios.post(
        `${config.API_BASE_URL}/Home/CreateCoupon`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Coupon created successfully!");
      setAmountType("");
      setAmount("");
    } catch (err) {
      console.error("Error creating coupon:", err.response || err);
      toast.error(err.response?.data || "Failed to create coupon");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card sx={{ borderRadius: 4, p: 2, boxShadow: 4 }}>
        <CardContent>
          <Typography
            variant="h5"
            align="center"
            sx={{ mb: 3, fontWeight: 700 }}
          >
            Coupon Master
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Box display="flex" flexDirection="column" gap={2}>

            {/* Coupon Amount Type */}
            <TextField
              select
              label="Coupon Amount Type"
              fullWidth
              value={amountType}
              onChange={(e) => setAmountType(e.target.value)}
            >
              <MenuItem value="PERCENT">Percent (%)</MenuItem>
              <MenuItem value="RUPEE">({Companycurrency})</MenuItem>
            </TextField>

            {/* Coupon Amount */}
            <TextField
              label="Coupon Amount"
              type="number"
              fullWidth
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <Button
              variant="contained"
              size="large"
              onClick={saveCoupon}
              sx={{ mt: 2 }}
            >
              Save Coupon
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
